import React, { createContext, useContext } from "react";

const UserData = createContext();

export const useUserData = () => useContext(UserData);

export const UserInfo = ({ children }) => {
  const userDetails = {
    name: "Sarah Siqueira",
    jobTitle: "Full Stack Developer",
    shortDescription:
      "Open-source enthusiast specializing in WordPress and Drupal development, including custom plugins/modules, tailored themes, and headless CMS architectures with Next.js since 2015. Experienced in designing and delivering scalable web applications, API-first integrations, and modern React-based frontends.",
    longDescription: `
        I am a full-stack developer with 9+ years of experience, skilled at quickly adapting to new technologies and frameworks, and always staying up to date with the latest trends in web development. 

        I started as a freelancer in 2015, working on Shopify and WordPress projects, which gave me hands-on experience with PHP, JavaScript, Ruby on Rails, Node.js, CSS, and SASS/SCSS, as well as deployment workflows using CI/CD pipelines with GitHub and Bitbucket, and managing cloud servers on DigitalOcean and AWS. 

        In 2018, I founded my own startup, taking responsibility for IT operations, UX/UI decisions, and marketing strategies. 

        More recently, I’ve focused on working internationally, collaborating with talented developers, product managers, and designers from the US, Pakistan, Mexico, Colombia, South Africa, and the UK. 

        A fun fact: I am a former accountant and eternal physics student, it may seem random, but I believe everything connects in the end.
        `,
    basedOn: "Brazil",
    socialMedia: {
      linkedin: "https://www.linkedin.com/in/sarahcssiqueira",
      github: "https://github.com/sarahcssiqueira",
      twitter: "https://twitter.com/sarahcssiqueira",
      devTo: "https://dev.to/sarahcssiqueira",
      email: "sarahcosiqueira@gmail.com",
    },
    apiToConsume: {
      devTo: "https://dev.to/api/articles?username=sarahcssiqueira",
      github: "https://api.github.com/users/sarahcssiqueira/repos",
    },
    gitHubPageDesc:
      "Some things ship to production, some scratch a personal itch, some exist to help other developers. Client work often lives behind NDAs, but here's a slice of what I can share, and what I care about.",
    blogPageDesc:
      "I write content about technology, programming, and sometimes, how I see the world. The main goal is writing for my own future reference (and avoid spending hours 'googling' for stuff I forgot), but I also hope something to be useful for other developers.",
  };

  return <UserData.Provider value={userDetails}>{children}</UserData.Provider>;
};
